// Format Time: From or To
function formatTimeInput(p_input)
{
    // Get the old value
    let oldValue = p_input.getAttribute('data-old-value') || '';
    
    // Parse the time value
    let value = p_input.value.replace(/[^0-9]/g, '');

    // Check the action
    let isDeleting = p_input.value.length < oldValue.length;

    // Check if the value length is enough for the semicolon insertion ":"
    if (value.length >= 2)
    {
        // Extract hours
        let hours = value.substring(0, 2);

        // Extract minutes
        let minutes = value.substring(2, 4);

        // Validate hours (00-23)
        if (parseInt(hours) > 23) hours = '00';
        
        // Validate minutes (00-59)
        if (minutes && parseInt(minutes) > 59) minutes = '00';
        
        // Add a semicolon
        p_input.value = (!isDeleting || minutes) ? hours + ':' + (minutes || '') : hours;
    }
    else
    {
        p_input.value = value;
    }

    // Store the current value for the next comparison
    p_input.setAttribute('data-old-value', p_input.value);

    // Move the cursor to the end of the input field
    p_input.setSelectionRange(p_input.value.length, p_input.value.length);
}
// SMY-8220 Required background (required-bg) of custom-required items: red while a shown item is
// empty, cleared otherwise. Called by the page 0 DA_onChange_customRequired on change, and by pages
// that set values with suppressed change events (the change DA does not fire for those).
function f_arrangeRequiredBg(p_items)
{
    p_items.forEach(function (v_itemId)
    {
        let element = document.getElementById(v_itemId);
        let container = element ? element.closest('div.custom-required') : null;

        if (!container)
        {
            return;
        }

        try
        {
            let item = apex.item(v_itemId);

            // getValidity does not exist for every item type
            let validity = typeof item.getValidity === 'function'
                ? item.getValidity()
                : { valid: true };

            let value = item.getValue();

            // Empty check, also handles array, null and undefined
            let isEmpty = value === '' ||
                          value === null ||
                          value === undefined ||
                          (Array.isArray(value) && value.length === 0);

            // A container inside a hidden block (e.g. a removed via, hidden with $x_Hide) is never marked;
            // an inactive tab hides by class, not inline style, so its items still count as shown
            let isShown = $(container).parents().addBack()
                                      .filter(function () { return this.style && this.style.display === 'none'; })
                                      .length === 0;

            let addBg = isShown && (!validity.valid || isEmpty);

            // Multiple-value items carry the class on their .apex-item-multi wrappers
            let multis = container.querySelectorAll('.apex-item-multi');

            if (multis.length > 0)
            {
                multis.forEach(multi => multi.classList.toggle('required-bg', addBg));
            }
            else
            {
                container.querySelectorAll('input:not([type="hidden"]), textarea, select, a-select .apex-item-comboselect')
                         .forEach(el => el.classList.toggle('required-bg', addBg));
            }
        }
        catch (e)
        {
            console.warn('custom-required check error:', v_itemId, e);
        }
    });
}